/* eslint-disable import/prefer-default-export */
/* Creates a listener for the beforeunload event to alert the user if they try to leave the page with unsaved changes */
import { onBeforeUnmount } from 'vue';
import usePlanningStore from '@/stores/planning/planning';

function isElementDirty(element) {
  const oldState = element?.getPlanning()?.lastSavedProjectVersion?.content.elements.find(el => el.id === element.id);
  return oldState && element.generateContentPatch(oldState).length > 0;
}

export function useAlertBeforeUnload(element, callback) {
  function alertBeforeUnload(event) {
    if (! isElementDirty(element)) return;

    event.preventDefault();
    event.returnValue = true; // legacy support Chrome/Edge < 119
    if (callback) callback();
  }

  window.addEventListener('beforeunload', alertBeforeUnload);
  onBeforeUnmount(() => window.removeEventListener('beforeunload', alertBeforeUnload));
}

export function useDebouncedAutoSave(element) {
  const planningStore = usePlanningStore();

  const debouncedAutoSave = _.debounce(() => {
    if (! isElementDirty(element)) return;
    planningStore.save();
  }, 20000);

  onBeforeUnmount(() => debouncedAutoSave.cancel());

  return debouncedAutoSave;
}
